import Collapse from './Collapse'
import CollapsePanel from './CollapsePanel'

Collapse.Panel = CollapsePanel
export default Collapse



// WEBPACK FOOTER //
// ./components/collapse/index.js